import { useLocation } from 'react-router-dom';

export function useUrl(): string {
  const currentPath = useLocation().pathname;
  const path = currentPath.replace('/embed', '');

  return `${window.location.protocol + '//' + window.location.host + path}`;
}
